import { render, staticRenderFns } from "./redeem.vue?vue&type=template&id=350031ba&scoped=true&"
import script from "./redeem.vue?vue&type=script&lang=js&"
export * from "./redeem.vue?vue&type=script&lang=js&"
import style0 from "./redeem.vue?vue&type=style&index=0&id=350031ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350031ba",
  null
  
)

export default component.exports